import { useSessionStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { ref } from "vue";
const commons = useSessionStorage("kb-com", { requestCountdown: null });

export const useGeneralStore = defineStore("general", () => {
	const activeMenu = ref<string | null>(null);
	const activeAccordion = ref<string | null>(null);
	const accordionsList = ref<any[]>([]);
	const loaderStatus = ref(false);
	const modalStatus = ref(false);
	const modalContentStatus = ref(false);

	const toggleMenu = (data: string | null) => {
		activeMenu.value = data;
	};

	const toggleAccordion = (data: string | null) => {
		activeAccordion.value = data;
	};

	const toggleLoader = () => {
		loaderStatus.value = !loaderStatus.value;
	};

	const toggleModal = () => {
		modalStatus.value = !modalStatus.value;
	};

	const toggleModalContent = () => {
		modalContentStatus.value = !modalContentStatus.value;
	};

	const setAccordionsList = (data: any[]) => {
		accordionsList.value = data;
	};

	const setCountdown = (data: any) => {
		commons.value.requestCountdown = data;
	};

	return {
		activeMenu,
		activeAccordion,
		loaderStatus,
		modalStatus,
		modalContentStatus,
		toggleMenu,
		toggleAccordion,
		toggleLoader,
		toggleModal,
		toggleModalContent,
		accordionsList,
		setAccordionsList,
		commons,
		setCountdown
	};
});
